import React from "react";
import useGlobalHook from "use-global-hook";

const initialState = {
    headerHeight: 0,
    detailTabBarHeight: 0,
    editTabBarHeight: 0,
    shareSelectBarHeight: 0,
    tabBarHeight: 0,
};

const actions = {
    setHeaderHeight: (store, value) => {
        store.setState({headerHeight: value});
    },
    setDetailTabBarHeight: (store, value) => {
        store.setState({detailTabBarHeight: value});
    },
    setEditTabBarHeight: (store, value) => {
        store.setState({editTabBarHeight: value});
    },
    setShareSelectBarHeight: (store, value) => {
        store.setState({shareSelectBarHeight: value});
    },
    setTabBarHeight: (store, value) => {
        store.setState({tabBarHeight: value});
    },
};

const useLayoutStore = useGlobalHook(React, initialState, actions);

export default useLayoutStore;
